module.exports = __webpack_public_path__ + "img/login_left.bd60c02e.png";